import { translationNotFound_da } from "./translationNotFound.da";
import { defineBilingualTranslations } from "./translationTypes";
import { translationNotFound_en } from "./translationNotFound.en";

export const translationNotFound = defineBilingualTranslations({
  da: translationNotFound_da,
  en: translationNotFound_en,
});
